import {getSiteUrl} from "@/helpers/functions";

export interface SeoSchemaPersonProps {
    slug: string;
    name: string;
    jobTitle: string;
    sameAs: string[];
}

export const buildPersonId = (siteUrl: string, slug: string): string =>
    `${siteUrl}/#person/${slug}`;

export function SeoSchemaPerson({slug, name, jobTitle, sameAs}: SeoSchemaPersonProps) {
    const siteUrl = getSiteUrl();
    const schema = {
        "@context": "https://schema.org",
        "@type": "Person",
        "@id": buildPersonId(siteUrl, slug),
        "name": name,
        "jobTitle": jobTitle,
        "worksFor": {"@id": `${siteUrl}/#organization`},
        "sameAs": sameAs,
    };

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{__html: JSON.stringify(schema)}}
        />
    );
}
